import * as React from "react";
const SvgTick = (props) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18 7L9.42857 17L6 13", stroke: "#5C5D61", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }));
export default SvgTick;
